module.exports = __webpack_public_path__ + "img/contact_center_agent-filled@2x.d5012f5a.png";